import {useEffect, useState} from 'react';
// @ts-ignore:next-line
import type {UseRangeSliderProps} from 'react-instantsearch';
// @ts-ignore:next-line
import {useRange} from 'react-instantsearch';
import Slider from '@mui/material/Slider';
import {
  InputAdornment,
  OutlinedInput,
  ThemeProvider,
  createTheme,
} from '@mui/material';

export function PriceRangeSlider(props: UseRangeSliderProps) {
  const {start, range, canRefine, refine} = useRange(props);
  const {min, max} = range;
  const [value, setValue] = useState([min, max]);

  const from = Math.max(min, Number.isFinite(start[0]) ? start[0] : min);
  const to = Math.min(max, Number.isFinite(start[1]) ? start[1] : max);

  useEffect(() => {
    setValue([from, to]);
  }, [from, to]);

  const theme = createTheme({
    palette: {
      primary: {
        main: '#ad1a23',
      },
      secondary: {
        main: '#d8d8d8',
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div className="grid gap-x-6 gap-y-2 grid-cols-2">
        <OutlinedInput
          id="outlined-adornment-amount"
          startAdornment={<InputAdornment position="start">€</InputAdornment>}
          value={value[0]}
          onChange={(e) => setValue([parseInt(e.target.value), value[1]])}
          size="small"
        />
        <OutlinedInput
          id="outlined-adornment-amount"
          startAdornment={<InputAdornment position="start">€</InputAdornment>}
          value={value[1]}
          onChange={(e) => setValue([value[0], parseInt(e.target.value)])}
          size="small"
        />
        <div className="col-span-2">
          <Slider
            value={value}
            min={min}
            max={max}
            onChange={(e, value) => setValue(value as number[])}
            onChangeCommitted={(e, value) => refine(value)}
            disabled={!canRefine}
            valueLabelDisplay="auto"
            step={100}
          />
        </div>
      </div>
    </ThemeProvider>
  );
}
